import React, { PropsWithChildren, useId } from 'react';

import { Paper, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

type Props = PropsWithChildren<{
  title: string;
  description?: string;
}>;

export default function VoucherFormSection({ title, description, children }: Props) {
  const titleId = useId();

  return (
    <Paper
      component="section"
      aria-labelledby={titleId}
      variant="outlined"
      sx={{
        p: { xs: 2, lg: 3 },
        borderRadius: 2,
        backgroundImage: (theme) =>
          `linear-gradient(${alpha(theme.palette.primary.main, 0.025)}, ${alpha(theme.palette.primary.main, 0.025)})`,
        '& .MuiOutlinedInput-root': { bgcolor: 'background.paper' },
      }}
    >
      <Stack spacing={2}>
        <Stack spacing={0.5}>
          <Typography id={titleId} component="h2" variant="h6" fontWeight={600}>
            {title}
          </Typography>
          {description && (
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          )}
        </Stack>
        {children}
      </Stack>
    </Paper>
  );
}
